import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";
import { getTranslation } from "utils/translation";

export const Error500 = () => {
  return (
    <ErrorAlert
      title={getTranslation("message", "ERROR.INTERNAL_SERVER")}
      errorCode={500}
      buttonTitle={getTranslation("resource", "TRY_AGAIN")}
      onClick={() => window.location.reload()}
    >
      <p>
        {getTranslation("message", "ERROR.APOLOGIZE_FOR_ANY_INCONVENIENCE")}
        <br />
        {getTranslation("message", "ERROR.PLEASE_CONTACT_SYNCBOX")}
      </p>
    </ErrorAlert>
  );
};
